import Immutable from 'immutable';
import { PageId } from 'records/Page';
import { RawRFIAttachment, RFIAttachment } from 'records/RFIAttachment';
import { SheetVersion } from './SheetVersion';

export type RFIAnswerId = string;

export interface RawRFIAnswer {
  id: RFIAnswerId;
  projectid: string;
  answer: string;
  pageids: PageId[];
  attachments: RawRFIAttachment[];
  reportinguseremail: string;
  respondingdate: number;
  reviewingemail: string;
  reviewingname: string;
  reviewingcompany: string;
}

export interface RFIAnswerData {
  id: RFIAnswerId;
  projectid: string;
  answer: string;
  pageids: Immutable.Set<PageId>;
  attachments: Immutable.List<RFIAttachment>;
  reportinguseremail: string;
  respondingdate: number;
  reviewingemail: string;
  reviewingname: string;
  reviewingcompany: string;
  sheetVersions: Immutable.List<SheetVersion>;
}

const defaultValues: RFIAnswerData = {
  id: '',
  projectid: '',
  answer: '',
  pageids: Immutable.Set<PageId>(),
  attachments: Immutable.List<RFIAttachment>(),
  reportinguseremail: '',
  respondingdate: 0,
  reviewingemail: '',
  reviewingname: '',
  reviewingcompany: '',
  sheetVersions: Immutable.List<SheetVersion>(),
};

export const RFIAnswerFactory = Immutable.Record(defaultValues, 'RFIAnswer');

export class RFIAnswer extends RFIAnswerFactory {
  static deserialize(rawRFIAnswer: RawRFIAnswer): RFIAnswer {
    const attachments = Immutable.List<RFIAttachment>(
      rawRFIAnswer.attachments.map(RFIAttachment.deserialize)
    );

    return new RFIAnswer({
      ...rawRFIAnswer,
      sheetVersions: Immutable.List<SheetVersion>(),
      pageids: Immutable.Set(rawRFIAnswer.pageids),
      attachments,
    });
  }

  serialize(): RawRFIAnswer {
    return this.toJS();
  }
}
